import React from 'react'

import './Footer.css'

export default ({ globalSettings, socialSettings, navLinks }) => (
  <footer className='Footer'>
    <div className='container'>
    	<div className='footerFlex'>
	      <div className='footerTextFirst'>
	      	© TUSHEK LTD. 2020 ALL RIGHTS RESERVED
	      </div>
	      <a href="./images/Tushek_privacy_policy.pdf" className='footerText'>
	      	PRIVACY POLICY
	      </a>
	      <div className='footerFollowUS'>
	      	<div className='footerTextLast'>FOLLOW US</div>
	      	<div style={{display:"flex",alignItems:"center",width:"130px",justifyContent:"space-between"}}>
		      	<a className="linkFooter" href="https://www.facebook.com/tushekautomobili/"><img className="footerFacebook" alt="facebook" src="./assets/icons/facebook.png" /></a>
		      	<a className="linkFooter" href="https://www.youtube.com/channel/UCDjdCJQR7KsFJ-zdXyDnRaQ"><img className="footerYoutube" alt="youtube" src="./assets/icons/youtube.png" /></a>
		      	<a className="linkFooter" href="https://www.instagram.com/tushek_supercars_official/"><img className="footerInstagram" alt="instagram" src="./assets/icons/instagram.png" /></a>
	      	</div>
	      </div>
	    </div>
    </div>
  </footer>
)



// WEBPACK FOOTER //
// ./src/components/Footer.js